


































import { ThreeHandler } from "./three/ThreeHandler";
import Loader from "./components/Loader.vue";
import Menu from "./components/Menu.vue";
import Caption from "./components/Caption.vue";
import WorkInfo from "./components/WorkInfo.vue";
import ErrorView from "./components/ErrorView.vue";
import { Event } from "three";
import { Prop, Component, Vue } from "vue-property-decorator";
import { GalleryData, WorkData } from "./types/models";
import { VRGALLERY, HTTP } from "./constants/constant";

@Component({
  components: {
    Loader,
    Menu,
    Caption,
    WorkInfo,
    ErrorView
  }
})
export default class Vrgallery extends Vue {
  // ThreeJS Handler
  private handler: ThreeHandler;

  static readonly CANVAS_ID: string = "#three_canvas";
  private isAccessedBySmartPhone: boolean = false;
  private isVisibleLoader: boolean = true;
  private isVisibleError: boolean = false;
  private isVisibleCanvas: boolean = false;
  private isVisibleMenu: boolean = false;
  private isVisibleCaption: boolean = false;
  private isVisibleMenuSection: boolean = false;
  private isVisibleWork: boolean = false;
  private captionTitle: string = "";
  private captionDescription: string = "";
  private galleryData: GalleryData | null = null;
  private workData: WorkData | null = null;
  private errorStatus: number = 0;
  private errorMessage: string = "";

  @Prop({ required: false, type: Object })
  readonly gallery!: GalleryData;

  created() {
    const w: WorkData = {
      artistId: this.gallery.artist_id,
      artistName: this.gallery.artist_name,
      artistThumbnailUrl: this.gallery.artist_thumbnail_url,
      workTitle: this.gallery.title,
      workDescription: this.gallery.description
    };

    this.workData = w;
  }

  mounted() {
    // check Whethere accessed by smartphone.
    this.checkIfAccessedBySmartPhone();

    // 暫定処理 （後に削除する）
    // SmartPhone からのアクセス時、/vrgalleries ページに戻る
    if (this.isAccessedBySmartPhone) {
      alert(
        "現在 SmartPhone からはご利用できません（近日公開予定）。\r\n" +
          "お手数ではございますが、パソコンのブラウザからご利用ください！" +
          "\r\n" +
          "\r\n" +
          "前ページに戻ります。"
      );
      this.isVisibleLoader = false;
      location.href = "/vrgalleries";
      return;
    }

    this.handler.setIsAccessedBySmartPhone(this.isAccessedBySmartPhone);
    this.createView();
    window.addEventListener("resize", () => this.handler.resize(), false);
  }

  constructor() {
    super();
    this.handler = new ThreeHandler();
  }

  /**
   * スマホからのアクセスかどうかをチェックする。
   *
   * @returns {boolean}
   */
  private checkIfAccessedBySmartPhone(): void {
    let userAgent: string = navigator.userAgent.toLowerCase();

    let deviceNames: string[] = ["iphone", "ipad", "android"];
    for (var name of deviceNames) {
      if (userAgent.indexOf(name) != -1) {
        this.isAccessedBySmartPhone = true;
        break;
      }
    }
  }

  /**
   * VRGallery の View を作成する。
   */
  public createView() {
    // Canvas Element 取得
    var element: HTMLCanvasElement | null = document.querySelector(
      Vrgallery.CANVAS_ID
    );

    // Canvas Element が存在しない場合終了
    if (element == null) {
      console.log("Not Found Canvas.");
      return;
    }

    // ThreeJS 関連の 初期準備実行
    this.handler.initialize(element);

    // 壁と床のテクスチャを貼る。暫定処置のため後々変更する予定。
    // 壁にテクスチャを貼る関数作成
    let funcAttachImageToWall = () => {
      this.handler.attachImageToObject(
        VRGALLERY.OBJECT.WALL_TYPE,
        "/img/vrgallery/wall/wall.jpg",
        15,
        15,
        () => {
          this.isVisibleLoader = false;
          this.isVisibleCanvas = true;
          this.isVisibleMenuSection = true;
        }
      );
    };
    // 床にテクスチャを貼る関数作成
    let funcAttachImageToFloor = (element: Element) => {
      this.handler.attachImageToObject(
        VRGALLERY.OBJECT.FLOOR_TYPE,
        "/img/vrgallery/floor/floor.jpg",
        10,
        10,
        funcAttachImageToWall
      );
    };

    // Scene を Load / Create
    this.handler.loadScene(
      // Scene ファイルのパス
      this.getSceneJsonPath(),
      // ロード後の処理。ここではレンダリングを行う。
      () => {
        this.handler.renderingScene(funcAttachImageToFloor);
      },
      // Load時のエラー発生時処理
      (error: ErrorEvent) => {
        // LoadingのViewを非表示にし、エラーのViewを表示する。
        let errorContent: XMLHttpRequest = error.target as XMLHttpRequest;
        this.errorStatus = errorContent.status;
        this.errorMessage = errorContent.statusText;
        if (this.errorStatus != HTTP.STATUS.OK) {
          // ErrorStatus の場合のみ表示を変更
          this.isVisibleError = true;
          this.isVisibleLoader = false;
        }
      }
    );
  }

  /**
   * Sceneファイルのパスを取得する。
   */
  public getSceneJsonPath(): string | null {
    return this.gallery.gallery_file_path;
  }

  /** 
   * Canvas をクリックした際の挙動。 
   */
  public clickCanvas(event: Event): void {
    if (this.closePopup()) {
      // 現状ポップアップなどが表示されている場合には非表示にする。
      return;
    }

    // クリックしたオブジェクトの取得
    let intersect: THREE.Intersection | null = this.handler.detectObject(
      event.offsetX,
      event.offsetY
    );
    if (intersect != null) {
      // Caption を表示する
      let caption: {[key:string]:string} | null = this.handler.getCaption(intersect.object);
      if (caption != null) {
        this.handler.isUpdateLocation(false);
        this.isVisibleCaption = false;
        this.setCaptionInfo(caption["title"], caption["description"]);
        this.isVisibleCaption = true;
      }
    }
  }

  private closePopup(): boolean {
    let isVisiblen: boolean =
      this.isVisibleMenu || this.isVisibleCaption || this.isVisibleWork;

    this.isVisibleWork = false;
    this.isVisibleMenu = false;
    this.isVisibleCaption = false;

    this.handler.isUpdateLocation(true);

    return isVisiblen;
  }

  public showWork(): void {
    this.isVisibleMenu    = false;
    this.isVisibleCaption = false;
    this.isVisibleWork    = true;
    this.handler.isUpdateLocation(false);
  }

  public toggleMenu(): void {
    if (this.isVisibleMenu) {
      this.closePopup();
    } else {
      this.isVisibleWork    = false;
      this.isVisibleCaption = false;
      this.handler.isUpdateLocation(false);
      this.isVisibleMenu    = true;
    }
  }

  public closeCaption(): void {
    this.isVisibleCaption = false;
    this.handler.isUpdateLocation(true);
  }

  public setCaptionInfo(title: string, description: string) {
    this.captionTitle = title;
    this.captionDescription = description;
  }
}
